import { instance } from '../instance'

/**
 * Send form to create new report
 *
 * @param {string} walletId - wallet UUID to create report for
 * @param {string} format - xml | pdf | csv | xlsx
 * @param {string} dateFrom
 * @param {string} dateTo
 * @param {string} type
 * @param {number} includeFeePayment - 0|1
 * @param {number} sendToEmail - 0|1
 * @param {string} description
 * @param {boolean|number} validate
 *
 * @return {Promise<import('axios').AxiosResponse<any>>}
 */

export const create = (
  {
    walletId,
    format,
    dateFrom,
    dateTo,
    type,
    includeFeePayment,
    sendToEmail,
    description,
  },
  { validate },
) => {
  return instance.post(
    `/v2/wallet/${walletId}/report`,
    {
      format,
      dateFrom,
      dateTo,
      type,
      includeFeePayment,
      sendToEmail,
      description,
    },
    {
      params: {
        validate: Number(validate),
      },
    },
  )
}
